module.exports = __webpack_public_path__ + "static/media/Unforgotten Forces logo-hi-res.9ebe322c.jpg";